<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-menu v-if="isCurrentUserAdmin" bottom left>
        <template v-slot:activator="{ on }">
            <v-btn fab class="white lighten-2" v-on="on">
                <v-icon>more_vert</v-icon>
            </v-btn>
        </template>

        <v-list>
            <v-list-tile v-if="isImage" @click="rotateLeft">
                <v-list-tile-content>
                    <v-list-tile-title>Retourner à gauche</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="grey lighten-1">rotate_left</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile v-if="isImage" @click="rotateRight">
                <v-list-tile-content>
                    <v-list-tile-title>Retourner à droite</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="grey lighten-1">rotate_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-divider></v-divider>
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-title class="text-xs-center">Tags</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-divider></v-divider>

            <v-list-tile v-for="tag in document.tags" :key="tag.slug">
                <v-list-tile-content>
                    <v-list-tile-title>{{ tag.name }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action @click="removeTag(tag.slug)">
                    <v-icon color="red lighten-1">clear</v-icon>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
    import {mapGetters} from "vuex";
    import {DOCUMENT_REMOVE_TAG, DOCUMENT_ROTATE} from "../../store/actions.type";
    import {DocumentService} from "../../services/document.service";

    export default {
        name: "DocumentFullScreenAdminMenu",
        props: {
            document: {
                type: Object,
                default: null
            }
        },
        computed: {
            ...mapGetters(["isCurrentUserAdmin"]),
            isImage: function () {
                return DocumentService.isImage(document);
            }
        },
        methods: {
            /**
             * Suppresson du tag
             */
            removeTag: function (tagSlug) {
                this.$store.dispatch(DOCUMENT_REMOVE_TAG, {
                    documentSlug: this.document.slug,
                    tagSlug: tagSlug
                });
            },

            /**
             * Rotation de l'image
             */
            rotateLeft: function () {
                this.$store.dispatch(DOCUMENT_ROTATE, {
                    documentSlug: this.document.slug,
                    angle: 90
                });
            },

            /**
             * Rotation de l'image
             */
            rotateRight: function () {
                this.$store.dispatch(DOCUMENT_ROTATE, {
                    documentSlug: this.document.slug,
                    angle: -90
                });
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
